export default {
    data: () => ({
        translations: {
            title: {
                el: "Δημιουργήστε τους κωδικούς σας",
                en: "Create your codes",
                it: "Crea i tuoi codici"
            },
            info: {
                el: `Μπορείτε να δημιουργήσετε τους δικούς σας κωδικούς ή τις δικές σας
                    φράσεις για να μοιράζετε πόντους και κουπόνια στους πελάτες σας με τηλεοπτικές
                    διαφημίσεις, διαφημίσεις στα μέσα κοινωνικής δικτύωσης ή ακόμη και με φυλλάδια.
                    Όταν οι πελάτες σας θα πληκτρολογήσουν τους κωδικούς, θα ανταμειφθούν με πόντους
                    ή πόντους + κουπόνια.`,
                en: `You can create your own codes or catch phrases to share 
                    points and coupons to your clients with TV ads, social media ads or even flyers. 
                    When your clients will type the codes they get rewarded with point or points + coupons`,
                it: `Puoi creare i tuoi codici o frasi per distribuire punti e coupon ai tuoi clienti con annunci televisivi, 
                    annunci sui social media o anche brochure. Quando i tuoi clienti inseriscono i codici, 
                    saranno ricompensati con punti o punti + coupon.`
            },
            create: {
                el: "Δημιουργία Νέου Κωδικού",
                en: "Create New Code",
                it: "Crea una nuova password"
            },
            code: {
                el: "Κωδικός",
                en: "Code",
                it: "Codice"
            },
            points: {
                el: "Πόντοι",
                en: "Points",
                it: "Punti"
            },
            acquired: {
                el: "Αποκτήθηκαν",
                en: "Acquired",
                it: "Acquisite"
            },
            redeemed: {
                el: "Εξαργυρωμένα",
                en: "Redeemed",
                it: "Riscattato"
            },
            available: {
                el: "Διαθέσιμα",
                en: "Available",
                it: "Disponibile"
            },
            actions: {
                el: "Επεξεργασία",
                en: "Actions",
                it: "Modifica"
            },
            social: {
                el: "Social Media",
                en: "Social Media",
                it: "Social Media"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            share: {
                el: "",
                en: "Share",
                it: ""
            },
            deleteCode: {
                el: "",
                en: "Delete Code",
                it: ""
            },
            areYouSure: {
                el: "",
                en: "Are you sure you want to delete",
                it: ""
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
